<ng-container [formGroup]="form()">
  <nz-form-item>
    <nz-form-label nzRequired>{{ 'changePsd.newPsd' | translate }}</nz-form-label>
    <nz-form-control [nzErrorTip]="newPsdError">
      <nz-input-password [(nzVisible)]="newPsdVisible">
        <input nz-input formControlName="newPsd">
      </nz-input-password>
    </nz-form-control>
    <ng-template #newPsdError>
      {{ 'changePsd.rules.prefix' | translate }}@for (requirement of requirements(); track requirement.key; let last = $last) {{{ requirement.key | translate: requirement.params }}{{ last ? '' : ', ' }}}
    </ng-template>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label nzRequired>{{ 'changePsd.confirmPsd' | translate }}</nz-form-label>
    <nz-form-control
      [nzValidateStatus]="form().hasError('psdMismatch') && form().controls.confirmPsd.dirty ? 'error' : form().controls.confirmPsd"
      [nzErrorTip]="form().hasError('psdMismatch') ? ('changePsd.mismatch' | translate) : ('changePsd.confirmPsd' | translate)">
      <nz-input-password [(nzVisible)]="confirmPsdVisible">
        <input nz-input formControlName="confirmPsd">
      </nz-input-password>
    </nz-form-control>
  </nz-form-item>
</ng-container>
